// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"dd758892","260":"45fef9ad","336":"fbed2d27","453":"88322c56","524":"fdc791c3","889":"d5ac5292"}[chunkId] + ".chunk.js";
};